import { TFunction } from 'i18next'
import * as Yup from 'yup'

export const generateNewOrderValidation = (
  t: TFunction,
): Yup.ObjectSchema<
  Yup.Shape<object | undefined, { startDate: Date; endDate: Date; pickupAt: string; returnAt: string }>,
  object
> => {
  return Yup.object().shape({
    startDate: Yup.date().required(t('common:selectStartDate')),
    endDate: Yup.date().required(t('common:selectEndDate')),
    pickupAt: Yup.string().required(t('common:required')).typeError(t('common:required')),
    returnAt: Yup.string().required(t('common:required')).typeError(t('common:required')),
  })
}

export const generateProlongationValidation = (
  t: TFunction,
): Yup.ObjectSchema<Yup.Shape<object | undefined, { startDate: Date; endDate: Date; returnAt: string }>, object> => {
  return Yup.object().shape({
    startDate: Yup.date().required(t('common:selectStartDate')),
    endDate: Yup.date().required(t('common:selectEndDate')),
    returnAt: Yup.string().required(t('common:required')).typeError(t('common:required')),
  })
}
